import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSelection } from '../context/SelectionContext';
import Product from '../components/Product';
import BackButton from '../components/BackButton';
import useDocumentTitle from '../hooks/useDocumentTitle';

const GROUPS = [
  { type: 'panel', title: 'Moduły PV' },
  { type: 'inwerter', title: 'Falowniki' },
  { type: 'magazyn', title: 'Magazyny' },
];

const Observed = () => {
  useDocumentTitle('Obserwowane produkty');
  const { favoritesList } = useSelection();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const byType = { panel: [], inwerter: [], magazyn: [] };
  favoritesList.forEach(({ product, productType }) => {
    if (byType[productType]) byType[productType].push(product);
  });
  const total = favoritesList.length;

  return (
    <div className="px-4 md:px-10 lg:px-24 mt-8 mb-16">
      <div className="mb-5"><BackButton /></div>
      <h1 className="text-2xl font-bold text-gray-900 mb-1">Obserwowane</h1>
      <p className="text-sm text-gray-500 mb-8">
        {total > 0 ? `Zapisane produkty: ${total}` : 'Brak zapisanych produktów'}
      </p>

      {total === 0 ? (
        <div className="flex flex-col items-center justify-center py-20 text-center">
          <p className="text-lg text-gray-400 mb-5">
            Nie obserwujesz jeszcze żadnych produktów.
          </p>
          <Link
            to="/panele"
            className="px-5 py-2.5 rounded-lg bg-blue-600 text-white text-sm font-semibold hover:bg-blue-500 transition-colors"
          >
            Przeglądaj produkty
          </Link>
        </div>
      ) : (
        <div>
          {GROUPS.filter(({ type }) => byType[type].length > 0).map(({ type, title }) => (
            <div key={type} className="mb-12 last:mb-0">
              <h2 className="text-lg sm:text-xl font-bold text-blue-600 mb-4">
                {title}{' '}
                <span className="text-gray-400 font-normal text-base">({byType[type].length})</span>
              </h2>
              <ul>
                {byType[type].map((p) => (
                  <Product key={`${type}:${p.id}`} product={p} productType={type} />
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Observed;
